import { createTheme } from '@mui/material';

let dark = true;
const darkTheme = createTheme({
    palette: {
        type: dark ? 'dark' : 'light',
    },
    typography: {
        fontFamily: "proximanova",
        bookH3: {
            lineHeight: '1.5rem',
            fontSize: '1.5rem',
            color: 'black',
            cursor: 'default'
        },
        uberartikelH3: {
            lineHeight: '2rem',
            color: 'white',
            fontSize: '2.5rem',
            textAlign: 'center',
            cursor: 'default'
        },
        redHeading: {
            color: '#ed1a3b !important',
            fontSize: '1.5rem',
            cursor: 'default'
        },
        grayBoxH4: {
            color: '#ed1a3b !important',
            fontSize: '1.5rem',
            cursor: 'default'
        },
        hsbody: {
            color: 'white !important',
            fontSize: '1rem'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1800
        }
    },
    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    bookH3: 'h3',
                    uberartikelH3: 'h3',
                    redHeading: 'h4',
                    grayBoxH4: 'h4',
                    hsbody: 'p'
                }
            }
        }
    }
});

darkTheme.typography.h1 = {
    fontSize: '3em',
    letterSpacing: '-0.01562em',
    lineHeight: '48px',
    fontWeigth: '700',
    [darkTheme.breakpoints.down('xs')]: {
        fontSize: '2.5em',
    },
};
darkTheme.typography.h2 = {
    fontSize: '2.572em',
    letterSpacing: '-0.01562em',
    lineHeight: '48px',
    [darkTheme.breakpoints.down('xs')]: {
        fontSize: '2em',
    },
};
darkTheme.typography.h3 = {
    fontSize: '1.875em',
    letterSpacing: '-0.01562em',
    lineHeight: '24px',
    [darkTheme.breakpoints.down('xs')]: {
        fontSize: '1.5em',
    },
};
darkTheme.typography.h4 = {
    fontSize: '1.286em',
    [darkTheme.breakpoints.down('xs')]: {
        fontSize: '1em',
    },
};
darkTheme.typography.body1 = {
    fontSize: '18px',
    letterSpacing: '0.00938em',
    [darkTheme.breakpoints.down('xs')]: {
        fontSize: '0.8rem',
    },
};

export default darkTheme;